import type { FC } from 'react';
import { FunnelStatusName } from 'src/modules/shared/components/atoms/funnel-status-name';
import Tag from 'src/modules/shared/components/atoms/tag';
import type { FooterStatusTagProps } from '../../types/conversation-card.type';

/** Shows the current funnel status in a compact badge. */
export const ConversationFooterStatusTag: FC<FooterStatusTagProps> = ({
  status,
}) => (
  <Tag
    content={
      <FunnelStatusName
        name={status.name}
        outcome={status.terminalOutcome}
        size="tiny"
        className="![font-size:inherit] ![font-weight:inherit] ![line-height:inherit]"
      />
    }
    size="xs"
    variant="neutral"
    appearance="soft"
    className="overflow-hidden max-w-full shrink-0"
  />
);
